import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { InvestorTypeEnum } from "../shared/enums/common.enum";
import {
  customEmailValidator,
  ibanValidator,
  sortCodeValidator, specialCharacterValidator,
  VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS,
  validDateValidator
} from "@shared/validators";
import { swiftBicValidator } from "@shared/validators/format.validators";

@Injectable({ providedIn: 'root' })
export class InvestorsFormProvider {
  investorsForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initInvestorsForm(data?: any): FormGroup {
    return this.fb.group({
      intermediaryId: [data?.intermediaryId],
      firstName: [data?.firstName, [Validators.required, VALIDATOR_ONLY_SPACES]],
      lastName: [data?.lastName, [Validators.required, VALIDATOR_ONLY_SPACES]],
      email: [data?.email, [Validators.required, customEmailValidator()]],
      birthDate: [data?.birthDate || null, [validDateValidator()]],
      home: [data?.phoneNumbers?.home, [Validators.maxLength(20)]],
      office: [data?.phoneNumbers?.office, [Validators.maxLength(20)]],
      mobile: [data?.phoneNumbers?.mobile, [Validators.maxLength(20)]],
      country: [data?.address?.country || '', [Validators.required, VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS]],
      countryCode: [data?.address?.countryCode],
      state: [data?.address?.state, [Validators.required, VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/),  Validators.maxLength(250)]],
      city: [data?.address?.city, [Validators.required, VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/), Validators.maxLength(250)]],
      area: [data?.address?.area, [VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/), Validators.maxLength(250)]],
      lineOne: [data?.address?.lineOne, [Validators.required, VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/), Validators.maxLength(250)]],
      lineTwo: [data?.address?.lineTwo, [VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/), Validators.maxLength(250)]],
      zipCode: [data?.address?.zipCode, [Validators.required, VALIDATOR_ONLY_SPACES, VALIDATOR_ONLY_SPECIAL_CHARACTERS, specialCharacterValidator(/[A-Za-z0-9\-_ ]/), Validators.maxLength(20)]],
      amount: [data?.amount],
      quotedRate: [data?.quotedRate],
      trustee: [data?.trustee || ''],
      savings: [data?.savings],
      sortCode: [data?.sortCode || '', [Validators.required, VALIDATOR_ONLY_SPACES, sortCodeValidator()]],
      account: [data?.account || '', [Validators.required, VALIDATOR_ONLY_SPACES, Validators.minLength(8), Validators.maxLength(50), Validators.pattern(/^[A-Za-z0-9]+$/)]],
      swiftBic: [data?.swiftBic || '', [VALIDATOR_ONLY_SPACES, swiftBicValidator()]],
      iban: ['', [Validators.required, VALIDATOR_ONLY_SPACES, ibanValidator()]],
      type: [data?.type || InvestorTypeEnum.Person],
    });
  }
}

